import React, { ReactNode } from 'react';
import { Button } from 'reactstrap';
import BaseModal from 'modules/Layout/component/Modal';
import Loader from 'modules/Layout/component/Loader';
import InformationList from 'modules/Layout/component/InformationList';
import {
  addToastAction,
  AddToastAction,
  AddToastPayload
} from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { AxiosResponse } from 'axios';
import {
  deleteMediaAdvancementToastError,
  deleteMediaAdvancementToastSuccess
} from 'modules/Media/toasts';
import { deleteMediaAdvancement } from 'modules/Media/repository';
import MediaAdvancement from 'modules/Media/model/MediaAdvancement';

export interface DispatchProps {
  addToast: (payload: AddToastPayload) => AddToastAction;
}

export interface Props extends DispatchProps {
  onSuccess?: (response: AxiosResponse) => void;
}

export interface State {
  isOpen: boolean;
  mediaAdvancement: MediaAdvancement;
  fetching: boolean;
}

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  addToast: (payload) => dispatch(addToastAction(payload))
});

export class DeleteMediaAdvancementModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false,
      mediaAdvancement: null,
      fetching: false
    };

    this.openModal = this.openModal.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.renderBody = this.renderBody.bind(this);
    this.renderTitle = this.renderTitle.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
  }

  openModal(mediaAdvancement: MediaAdvancement): void {
    this.setState({
      isOpen: true,
      fetching: false,
      mediaAdvancement
    });
  }

  toggle(): void {
    this.setState({
      isOpen: false
    });
  }

  async onSubmit(): Promise<void> {
    const { onSuccess, addToast } = this.props;
    const { mediaAdvancement } = this.state;

    this.setState({
      fetching: true
    });

    try {
      const response = await deleteMediaAdvancement(mediaAdvancement.id);

      addToast(deleteMediaAdvancementToastSuccess());

      this.setState({
        isOpen: false
      });

      if (onSuccess) {
        onSuccess(response);
      }
    } catch (error) {
      console.log(error);
      addToast(deleteMediaAdvancementToastError());
    }
  }

  renderTitle = (): React.ReactNode => {
    return 'Do you want to delete media advancement?';
  };

  renderBody(): React.ReactNode {
    const { fetching, mediaAdvancement } = this.state;

    const fields = [
      {
        label: 'Name:',
        value: mediaAdvancement.name
      }
    ];

    return (
      <>
        {fetching && <Loader />}
        <InformationList fields={fields} />
      </>
    );
  }

  renderFooter(): React.ReactNode {
    const { fetching } = this.state;

    return (
      <div className="d-flex justify-content-between w-100">
        <Button disabled={fetching} color="primary" onClick={this.toggle}>
          Cancel
        </Button>
        <Button disabled={fetching} color="danger" onClick={this.onSubmit}>
          Delete
        </Button>
      </div>
    );
  }

  render(): ReactNode {
    const { isOpen, mediaAdvancement } = this.state;

    if (!mediaAdvancement) {
      return null;
    }

    return (
      <BaseModal
        isOpen={isOpen}
        title={this.renderTitle()}
        body={this.renderBody()}
        footer={this.renderFooter()}
        toggle={this.toggle}
      />
    );
  }
}

export default connect<null, DispatchProps>(null, mapDispatch, null, {
  forwardRef: true
})(DeleteMediaAdvancementModal);
